/* eslint-env jquery */

"use strict";

/**
 * Initialize the quantity component
 * @param {Array<DOM>} quantityWrappers 
 */
function loadQuantityComponent(quantityWrappers) {
    quantityWrappers.forEach(wrapper => {
        const input = $(wrapper).find(".quantity-input");
        const minusButton = $(wrapper).find(".quantity-control[data-action=\"down\"]");
        const plusButton = $(wrapper).find(".quantity-control[data-action=\"up\"]");
        var bootstrapData = {};
        var options = {};

        // Parse the data-bootstrap attribute to get min and max values
        function controlCheck() {
            bootstrapData = JSON.parse(wrapper.getAttribute("data-bootstrap"));
            options = {
                minValue: bootstrapData.quantity.minValue,
                maxValue: bootstrapData.quantity.maxValue,
                productId: bootstrapData.quantity.productId,
                dynamicWidth: bootstrapData.quantity.dynamicWidth,
                disabledClassName: "-disabled"
            };

            if (input.val() <= options.minValue) {
                minusButton.addClass(options.disabledClassName);
            } else {
                minusButton.removeClass(options.disabledClassName);
            }

            if (input.val() >= options.maxValue) {
                plusButton.addClass(options.disabledClassName);
            } else {
                plusButton.removeClass(options.disabledClassName);
            }

            if (options.dynamicWidth) {
                input.width(input.val().length + 1 + "ch");
            }
        }

        controlCheck();

        $(wrapper).find(".quantity-control").on("click", e => {
            if (input.is(":disabled") || $(e.target).hasClass(options.disabledClassName)) return;
            const elementInputValue = +input.val();
            const action = e.target.getAttribute("data-action");
            if (action === "up" && elementInputValue < options.maxValue) {
                input.val(elementInputValue + 1);
            } else if (action === "down" && elementInputValue > options.minValue) {
                input.val(elementInputValue - 1);
            } else { return; }

            input.change();
            controlCheck();
        });

        input.on("input", e => {
            const messageContainer = $(`#quantityMessage-${e.target.dataset.pid}`); // Replace with your actual message container selector

            if (e.target.value.length < 1) return;

            if ($.isNumeric(e.target.value)) {
                if (e.target.value > options.maxValue) {
                    e.target.value = options.maxValue;
                    messageContainer.text(`${options.maxValue} item(s) in stock`);
                    messageContainer.show(); // Ensure the message is visible
                } else {
                    messageContainer.hide(); // Hide the message if the quantity is valid
                }

                if (e.target.value < options.minValue) {
                    e.target.value = options.minValue;
                }
            } else {
                e.target.value = options.minValue;
            }

            e.target.previousValue = e.target.value;

            controlCheck();
        });

        input.on("focus", e => {
            e.target.previousValue = e.target.value;
        });

        input.on("change", e => {
            if (!e.target.value.length) e.target.value = e.target.previousValue || options.minValue;
        });

        $(wrapper).on("count:update", (e, response) => {
            let addedQuantity = 0;
            const items = response?.cart?.items || response.items || [];
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.id == options.productId) {
                    addedQuantity += item.quantity;
                    if (item?.quantityOptions?.maxOrderQuantity) {
                        options.maxValue = item.quantityOptions.maxOrderQuantity - addedQuantity;
                    }
                }
            }
            controlCheck();
        });
    });
}

/**
 * Updates the HTML with the variation max quantity
 * @param {Array<DOM>} quantityWrappers 
 * @param {number} maxQuantity 
 */
function updateControlCheck(quantityWrappers, maxQuantity) {
    if (quantityWrappers && maxQuantity) {
        quantityWrappers.forEach(wrapper => {
            const bootstrapData = JSON.parse(wrapper.getAttribute("data-bootstrap"));
            bootstrapData.quantity.maxValue = maxQuantity;
            wrapper.setAttribute("data-bootstrap", JSON.stringify(bootstrapData));
            $(wrapper).find(".quantity-input").trigger("input");
        });
    }
}

module.exports = {
    /**
     * Loads the quantity component for all elements with the class "quantity-wrapper".
     * This function selects all elements with the class "quantity-wrapper" from the DOM
     * and initializes the quantity component for each of them.
     */
    loadQuantityComponent: function (quantityWrappers) {
        // Select all quantity wrappers
        if (!quantityWrappers) {
            quantityWrappers = document.querySelectorAll(".quantity-wrapper");
        }
        loadQuantityComponent(quantityWrappers);
    },
    updateControlCheck: function (quantityWrappers, maxQuantity) {
        updateControlCheck(quantityWrappers, maxQuantity);
    }
};
